import { useParams } from 'react-router';

import { Card, ErrorCallout } from '../../shared';
import { Box, Flex } from '../../shared/components';
import { useAccount } from '../hooks/useAccount';

import { AccountHeading } from './AccountHeading';
import { DiagnosticUsageTab } from './DiagnosticUsageTab';

export function DiagnosticUsageOverviewPage() {
  const { accountId } = useParams<{ accountId: string }>();

  // Fetch account data. Hooks must run unconditionally, so this is called
  // before the accountId guard below; useAccount disables its query when
  // accountId is empty.
  const accountQuery = useAccount(accountId ?? '');

  if (!accountId) {
    return (
      <div>
        <ErrorCallout>
          <strong>Invalid URL</strong>
          <p>Missing account ID in the URL.</p>
        </ErrorCallout>
      </div>
    );
  }

  const account = accountQuery.data?.entities?.accounts?.[accountId];

  if (accountQuery.isLoading) {
    return (
      <div className="DiagnosticUsageOverviewPage">
        <Flex>
          <Box width={1} p={2}>
            <Card>
              <div>Loading account data...</div>
            </Card>
          </Box>
        </Flex>
      </div>
    );
  }

  if (accountQuery.error || !account) {
    return (
      <div className="DiagnosticUsageOverviewPage">
        <Flex>
          <Box width={1} p={2}>
            <Card>
              <ErrorCallout>
                <strong>Failed to load account data</strong>
                <p>Account not found or could not be loaded.</p>
              </ErrorCallout>
            </Card>
          </Box>
        </Flex>
      </div>
    );
  }

  return (
    <div className="DiagnosticUsageOverviewPage">
      <AccountHeading account={account} />
      <DiagnosticUsageTab account={account} />
    </div>
  );
}
